import QrReader from "react-qr-reader";
import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import CardContent from "@origyn-sa/common-ui/src/components/atoms/CardContent";
import { H3 } from "@origyn-sa/common-ui/src/components/atoms/H/H.styled";
import Form from "@origyn-sa/common-ui/src/components/templates/Form";
import InputField from "@origyn-sa/common-ui/src/components/molecules/InputField";
import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import Label from "@origyn-sa/common-ui/src/components/atoms/Label";
import { ProductCardInput } from "../../utils";

export interface ITransferItemModal {
  open: boolean;
  onClose?: () => void;
  item: ProductCardInput;
  onTransfer: (val: any) => void;
}

const TransferItemModal = ({
  open,
  onClose,
  item,
  onTransfer,
}: ITransferItemModal) => {
  const [recipient, setRecipient] = useState("");
  const [memo, setMemo] = useState("");

  const [qrCode, setQrCode] = useState(false);

  const onSubmit = (data: any) => {
    console.log("onSubmit", data);
    if (onTransfer)
      onTransfer({
        recipient,
        memo,
      });
  };

  const onClickHandler = () => {
    setQrCode(!qrCode);
  };

  const onCodeHandler = (data: string | null) => {
    console.log(data);
    if (data) {
      setQrCode(false);
      setRecipient(data);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <CardContent textAlign='center' padding='40px 55px'>
        <Grid container justify='center' spacing={1}>
          <Grid item>
            <H3 spacing={[0, 3]}>Transfer</H3>
          </Grid>
        </Grid>
        <br />

        <Form onSubmit={onSubmit}>
          <Grid item xs={12}>
            <InputField
              disabled
              label='Token ID'
              defaultValue={item.id}
              name='principal'
              placeholder='Principal'
            />
            <InputField
              required
              label='Recipient Principal'
              name='principal'
              defaultValue={recipient}
              onChange={(e: any) => {
                setRecipient(e.target.value);
              }}
              placeholder='Principal'
            />
            <Label
              style={{
                marginTop: "-30px",
                marginBottom: "24px",
                textAlign: "right",
              }}
              onClick={onClickHandler}
            >
              {qrCode ? "Close" : "Scan"} QR-Code
            </Label>
            {qrCode && (
              <div>
                <QrReader
                  delay={300}
                  onError={(err: any) => {
                    console.error(err);
                  }}
                  onScan={onCodeHandler}
                  style={{ width: "100%" }}
                />
              </div>
            )}
            <InputField
              label='Memo (optional)'
              name='memo'
              defaultValue={memo}
              onChange={(e: any) => {
                setMemo(e.target.value);
              }}
              placeholder='Thanks for the ICPs'
            />
          </Grid>
          <Button type='submit' spacing={2}>
            Transfer
          </Button>
        </Form>
      </CardContent>
    </Dialog>
  );
};

export default TransferItemModal;
